module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire",
      "standalone": ""
    }
  }, [(_vm.isAuthenticated) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "persistent": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "teal",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-tile-action', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.userPayload.role))]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.userPayload.FullName))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.userMenu), function(section) {
    return _c('v-list-group', {
      key: section.Title,
      attrs: {
        "group": section.Title,
        "prepend-icon": section.Icon,
        "no-action": "no-action"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "ripple": "ripple"
      },
      on: {
        "click": function($event) {
          return _vm.navigate(section.Path)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(section.Title))])], 1)], 1), _vm._v(" "), _vm._l((section.Pages), function(subItem) {
      return _c('v-list-tile', {
        key: subItem.Title,
        staticStyle: {
          "margin-left": "-25px"
        },
        on: {
          "click": function($event) {
            return _vm.navigate(subItem.Path)
          }
        }
      }, [(subItem.Icon) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(subItem.Icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(subItem.Title))])], 1)], 1)
    })], 2)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "indigo darken-4",
    attrs: {
      "fixed": "",
      "app": "",
      "dark": ""
    }
  }, [(_vm.isAuthenticated) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Маркет АП")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.screenWidth > 500) ? [(_vm.isAuthenticated) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Выйти")]) : _vm._e()] : [(_vm.isAuthenticated) ? _c('v-icon', {
    attrs: {
      "color": "white"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("fa-sign-out")]) : _vm._e()]], 2), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view', {
    on: {
      "refresh": _vm.refresh
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb88be06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 337
// module chunks = 11